import axios from 'axios'
import { CreateToken } from '@/helpers/jwtHelpers.js'
import { GetApiBaseUrl } from '@/helpers/apiBaseUrl.js'

const imagePath = (boqId, itemId, imageContextType = 'boq') => {
  const contextPath = imageContextType === 'high-level' ? '/high-level-estimate/boq' : ''
  return `${GetApiBaseUrl()}/api/boq${contextPath}/${encodeURIComponent(boqId)}/items/${encodeURIComponent(itemId)}/images`
}

async function requestConfig() {
  return {
    withCredentials: true,
    headers: { Authorization: `Bearer ${await CreateToken(0)}` }
  }
}

export async function GetBoqItemImages(boqId, itemId, imageContextType = 'boq') {
  const response = await axios.get(imagePath(boqId, itemId, imageContextType), await requestConfig())
  return response.data
}

export async function GetBoqImageSummaries(boqId, itemIds, imageContextType = 'boq') {
  const contextPath = imageContextType === 'high-level' ? '/high-level-estimate/boq' : ''
  const response = await axios.get(`${GetApiBaseUrl()}/api/boq${contextPath}/${encodeURIComponent(boqId)}/images`, {
    ...await requestConfig(),
    params: { itemIds: itemIds.join(',') }
  })
  return response.data
}

export async function GetBoqItemImageContent(boqId, itemId, imageId, { signal, imageContextType = 'boq' } = {}) {
  const response = await axios.get(`${imagePath(boqId, itemId, imageContextType)}/${encodeURIComponent(imageId)}/content`, {
    ...await requestConfig(),
    responseType: 'blob',
    timeout: 35000,
    signal
  })
  return response.data
}

export async function UploadBoqItemImage(boqId, itemId, file, onUploadProgress, imageContextType = 'boq') {
  const form = new FormData()
  form.append('image', file)
  const response = await axios.post(imagePath(boqId, itemId, imageContextType), form, {
    ...await requestConfig(),
    onUploadProgress
  })
  return response.data
}

export async function DeleteBoqItemImage(boqId, itemId, imageId, imageContextType = 'boq') {
  await axios.delete(`${imagePath(boqId, itemId, imageContextType)}/${encodeURIComponent(imageId)}`, await requestConfig())
}
